/**
 * The Artists container
 */
import { env } from "@bkry/bowline-utils";
import PropTypes from "prop-types";
import React from "react";
import { Container } from "reactstrap";
import ArtistsIntro from "../components/ArtistsIntro";
import Page from "../components/Page/Page-component";
import BundleSection from "../components/PreorderBundleSection/BundleSection-component";
import SectionWithModal from "../components/SectionWithModal";
import {
  authieArray,
  charlotteArray,
  fleckArray,
  jaidenArray,
  plasticPenArray,
  specterArray,
  tudiscoArray,
  urliArray,
} from "../components/utils/ArtistModalImageArray";
const { REACT_APP_CDN_PATH } = env;

/**
 * Artists container, the landing page for logged in users
 */
const Artists = (props, context) => {
  const poapArtists = [
    {
      id: 1,
      subtitle: context.t("artist.jaiden.subtitle"),
      title: context.t("artist.jaiden.title"),
      text: context.t("artist.jaiden.text"),
      image: "/images/Jaiden/750/750x720_Jaiden.png",
      modal: {
        subHeader: context.t("artist.modal.jaiden.subHeader"),
        headline: context.t("artist.modal.jaiden.headline"),
        text: context.t("artist.modal.jaiden.text"),
        items: jaidenArray,
        twitter: "https://twitter.com/jastidesigns",
        insta: "https://www.instagram.com/jastidesigns/?hl=de",
      },
    },
    {
      id: 2,
      subtitle: context.t("artist.specter.subtitle"),
      title: context.t("artist.specter.title"),
      text: context.t("artist.specter.text"),
      image: "/images/Specter/750/750x720_SPecter.png",
      modal: {
        subHeader: context.t("artist.modal.specter.subHeader"),
        headline: context.t("artist.modal.specter.headline"),
        text: context.t("artist.modal.specter.text"),
        items: specterArray,
        twitter: "https://twitter.com/SpecterBerlin",
        insta: "https://www.instagram.com/specter/?hl=de",
      },
    },
    {
      id: 3,
      subtitle: context.t("artist.plastic_pen.subtitle"),
      title: context.t("artist.plastic_pen.title"),
      text: context.t("artist.plastic_pen.text"),
      image: "/images/Stefan/750/750x720_Stefan.png",
      modal: {
        subHeader: context.t("artist.modal.plastic_pen.subHeader"),
        headline: context.t("artist.modal.plastic_pen.headline"),
        text: context.t("artist.modal.plastic_pen.text"),
        items: plasticPenArray,
        twitter: "https://twitter.com/grossehalbuer",
        insta: "https://www.instagram.com/plastic.pen/?hl=de",
      },
    },
    {
      id: 4,
      subtitle: context.t("artist.thomas.subtitle"),
      title: context.t("artist.thomas.title"),
      text: context.t("artist.thomas.text"),
      image: "/images/Thomas/750x720/750x720_Thomas.png",
      modal: {
        subHeader: context.t("artist.modal.thomas.subHeader"),
        headline: context.t("artist.modal.thomas.headline"),
        text: context.t("artist.modal.thomas.text"),
        items: fleckArray,
        insta: "https://www.instagram.com/atmogram/?hl=de",
      },
    },
  ];

  const artNftArtists = [
    {
      id: 1,
      subtitle: context.t("artist.tudisco.subtitle"),
      title: context.t("artist.tudisco.title"),
      text: context.t("artist.tudisco.text"),
      image: "/images/Antoni/750/750x720_Antoni.png",
      modal: {
        subHeader: context.t("artist.modal.tudisco.subHeader"),
        headline: context.t("artist.modal.tudisco.headline"),
        text: context.t("artist.modal.tudisco.text"),
        items: tudiscoArray,
        twitter: "https://twitter.com/antonitudisco",
        insta: "https://www.instagram.com/antonitudisco/?hl=de",
      },
    },
    {
      id: 2,
      subtitle: context.t("artist.bruno.subtitle"),
      title: context.t("artist.bruno.title"),
      text: context.t("artist.bruno.text"),
      image: "/images/Bruno/750/750x720_Bruno.png",
      modal: {
        subHeader: context.t("artist.modal.bruno.subHeader"),
        headline: context.t("artist.modal.bruno.headline"),
        text: context.t("artist.modal.bruno.text"),
        items: urliArray,
        twitter: "https://twitter.com/brunourIi",
        insta: "https://www.instagram.com/brunourli/?hl=de",
      },
    },
    {
      id: 3,
      subtitle: context.t("artist.charlotte.subtitle"),
      title: context.t("artist.charlotte.title"),
      text: context.t("artist.charlotte.text"),
      image: "/images/charlotte/750/750x720_Charlotte.png",
      modal: {
        subHeader: context.t("artist.modal.charlotte.subHeader"),
        headline: context.t("artist.modal.charlotte.headline"),
        text: context.t("artist.modal.charlotte.text"),
        items: charlotteArray,
        twitter: "https://twitter.com/StudioCTaylor",
        insta: "https://www.instagram.com/charlottetaylr/?hl=de",
      },
    },
    {
      id: 4,
      subtitle: context.t("artist.authie.subtitle"),
      title: context.t("artist.authie.title"),
      text: context.t("artist.authie.text"),
      image: "/images/Authie/750/750x720_Hero_Anthony.png",
      modal: {
        subHeader: context.t("artist.modal.authie.subHeader"),
        headline: context.t("artist.modal.authie.headline"),
        text: context.t("artist.modal.authie.text"),
        items: authieArray,
        twitter: "https://twitter.com/StudioZyva",
        insta: "https://www.instagram.com/zyvastudio/",
      },
    },
  ];

  return (
    <Page id="artist" title="MX1 Artists">
      <Container className="pb-5">
        <div className="d-flex justify-content-center">
          <img
            src={(REACT_APP_CDN_PATH || "") + "/images/ALL_ARTISTS.png"}
            width="100%"
            height="auto"
            alt="all-artists"
          />
        </div>
        <ArtistsIntro
          subtitle={context.t("artistIntro.genesis.subtitle")}
          title={context.t("artistIntro.genesis.title")}
          smallText={context.t("artistIntro.genesis.smallText")}
          bigText={context.t("artistIntro.genesis.bigText")}
        />
        {poapArtists.map((section) => (
          <SectionWithModal section={section} key={section.id} />
        ))}
        <BundleSection />
        <ArtistsIntro
          subtitle={context.t("artistIntro.art.subtitle")}
          title={context.t("artistIntro.art.title")}
          smallText={context.t("artistIntro.art.smallText")}
          bigText={context.t("artistIntro.art.bigText")}
        />
        {artNftArtists.map((section) => (
          <SectionWithModal section={section} key={section.id} />
        ))}
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
Artists.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default Artists;
